import { render, staticRenderFns } from "./social-auth.vue?vue&type=template&id=e2db3b22&scoped=true&"
import script from "./social-auth.vue?vue&type=script&lang=js&"
export * from "./social-auth.vue?vue&type=script&lang=js&"
import style0 from "./social-auth.vue?vue&type=style&index=0&id=e2db3b22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2db3b22",
  null
  
)

export default component.exports